export default __webpack_public_path__ + "static/media/face2.40a383c6.svg";